import React from "react";
import { FormControlLabel, Typography } from "@material-ui/core";

import StyledCheckbox from "./Checkbox";

export default function CheckBox({ value, onChange, label, disabled }) {
  return (
    <FormControlLabel
      style={{ paddingLeft: 9, fontSize: "12px", marginRight: 0 }}
      control={
        <StyledCheckbox
          checked={value}
          onChange={onChange}
          size="small"
          color="primary"
          style={{ padding: 0, marginRight: 5 }}
          disabled={disabled}
        />
      }
      label={<Typography style={{ fontSize: 13, color: "rgba(0,0,0,.87)" }}>{label}</Typography>}
    />
  );
}
